module.exports = __webpack_public_path__ + "img/cart-hen-remove-bg.98221732.png";